<div class="width-full flex-fill">
  <div class="grid-container padding-x-2 tablet:padding-x-4 desktop:padding-x-0">
    <div class="grid-row">
      <div class="grid-col-12 desktop:grid-col-10 desktop:grid-offset-1">
        <nav class="usa-breadcrumb" aria-label="Breadcrumbs">
          <ol class="usa-breadcrumb__list">
            <li class="usa-breadcrumb__list-item">
              <a class="usa-breadcrumb__link" [href]="homeUrl">Home</a>
            </li>
            <li class="usa-breadcrumb__list-item usa-current" aria-current="page">
              <span>{{ pageTitle }}</span>
            </li>
          </ol>
        </nav>
      </div>
      <div class="grid-col-12 desktop:grid-col-10 desktop:grid-offset-1">
        <div class="border-bottom-1px border-base-light"></div>
      </div>
    </div>    
    
    <div class="tablet:display-none margin-top-105" [hidden]="!showMapAlert">
      <div class="usa-alert usa-alert--info usa-alert--slim margin-bottom-3" id="hdwMapAlert">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            For a better experience, please view this page on desktop.
          </p>
          <div class="position-absolute top-1 right-2">
            <button (click)="dismissMapAlert()" class="usa-button--unstyled usa-link usa-link--dark usa-link--semibold cursor-pointer" title="Dismiss">
              <i class="fa-solid fa-close"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <main id="main-content">
      <section aria-label="Summary" class="grid-row margin-top-4 tablet:margin-top-5">
        <div class="grid-col-12 desktop:grid-col-10 desktop:grid-offset-1">
          <div class="padding-bottom-6 tablet:padding-bottom-5 border-bottom-1px border-base-light margin-bottom-2">
            <div class="grid-row grid-gap-3">
              <div class="grid-col-12 desktop:grid-col-8 margin-bottom-3 desktop:margin-bottom-0">
                <h1 class="font-heading-xl tablet:font-heading-2xl text-bold margin-top-0 margin-bottom-2 tablet:margin-y-0">
                  {{ this.pageTitle }}
                </h1>
                @if (this.subHeaderText) {
                  <p class="font-body-md tablet:font-body-lg line-height-body-3 text-base-darker line-height-serif-2 margin-top-2 margin-bottom-1">
                    {{ this.subHeaderText }}
                  </p>
                }
              </div>
              <div class="grid-col-12 desktop:grid-col-4 display-block tablet:display-flex flex-column desktop:display-block">
                <div class="tablet:display-flex tablet:flex-row desktop:display-block desktop:text-right font-body-xs line-height-serif-4">
                  <div>
                    <a [href]="contactLink" target="_blank" rel="noopener noreferrer"
                      class="usa-link usa-link--dark usa-link--novisited text-no-wrap tablet:border-right-1px tablet:border-base tablet:padding-right-2 tablet:margin-right-2 desktop:margin-right-0 desktop:padding-0 desktop:border-0">
                      <i class="fa-solid fa-envelope margin-right-05"></i><span>Contact Project Team</span></a>
                  </div>
                  <div class="desktop:text-right font-body-xs line-height-serif-4">
                    <a href="javascript:void(0)" aria-controls="share-modal" data-open-modal
                      class="usa-link usa-link--dark text-no-wrap border-right-1px border-base padding-right-2 margin-right-2">
                      <i class="fa-solid fa-share margin-right-05"></i><span>Share</span></a>
                    <a href="javascript:window.print()" class="usa-link usa-link--dark text-no-wrap">
                      <i class="fa-solid fa-print margin-right-05"></i><span>Print</span></a>
                  </div>
                </div>
                <hdw-resource-content></hdw-resource-content>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      @if (!displayResults) {
        <section aria-label="Search" class="grid-row margin-bottom-8 tablet:margin-bottom-10">
          <div class="grid-col-12 desktop:grid-col-10 desktop:grid-offset-1">
            <hdw-loader [canShow]="canShowLoader"></hdw-loader>
            <div class="usa-form maxw-tablet">
              <fieldset class="usa-fieldset">
                <legend class="usa-legend usa-legend--large">
                  Search Criteria
                </legend>
                <p>
                  Required fields are marked with an asterisk (<abbr title="required" class="usa-hint usa-hint--required">*</abbr>).
                </p>
                <label class="usa-label text-semibold" for="search-field">
                  Search by City, State, or Zip
                  <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <div class="usa-search usa-search--small display-flex margin-top-1">
                  <input aria-label="Enter a Location"
                        placeholder="Enter a Location"
                        id="search-field"
                        class="usa-input radius-left-md" 
                        type="search"
                        [(ngModel)]="nameSuggestion"
                        (ngModelChange)="handleNameSuggestion()"
                        (keydown.enter)="handleSearch()" 
                  />
                  <button class="usa-button flex-1 radius-left-0 margin-0" aria-label="Search" (click)="handleSearch()">
                    <i class="fa-regular fa-magnifying-glass"></i>
                  </button>
                </div>

                <div class="search-container margin-top-0 margin-right-6" [ngClass]="{ 'hide-search-options': !canShowNameSuggestions }">
                  <ul class="esri-menu__list esri-search__suggestions-list search-wrapper">
                    @for (suggestionItem of nameSuggestionResults.suggestions; track suggestionItem) {
                      <li
                        (click)="handleSelectNameSuggestion(suggestionItem.text)"
                        class="search-option padding-105 cursor-pointer border-1px border-top-0 border-base hover:bg-base-lightest"
                        [innerHtml]="suggestionItem.formattedText"
                      ></li>
                    }
                  </ul>
                </div>

                <label class="usa-label text-semibold" for="radius-field">Radius </label>
                <select class="usa-select maxw-full margin-top-1"
                        id="radius-field"
                        aria-label="Radius"
                        [(ngModel)]="selectedRadius"
                        (change)="handleRadiusChange()">
                  @for (radiusItem of radiiForLocations; track radiusItem) {
                    <option [value]="radiusItem.value" [attr.aria-label]="radiusItem.displayText">
                      {{ radiusItem.displayText }}
                    </option>
                  }
                </select>
              </fieldset>
            </div>
          </div>
        </section>
      } 
      @else {
        <section aria-label="Search Results" class="grid-row">
          <div class="grid-col-12 desktop:grid-col-10 desktop:grid-offset-1">
            <hdw-loader [canShow]="canShowLoader"></hdw-loader>
            <div class="grid-row">
              <div class="grid-col-12 margin-bottom-3">
                <div class="tablet:display-flex flex-justify flex-align-center">
                  <h2 class="font-heading-lg margin-0">
                    Search results within {{ selectedRadius }} miles of {{ nameSuggestion }}
                  </h2>
                  <div class="margin-top-2 tablet:margin-top-0 display-flex flex-align-center">
                    <span class="margin-0 margin-right-105 text-no-wrap">Search another address</span>
                    <button type="submit" 
                            class="usa-button display-none tablet:display-block margin-right-0"
                            (click)="handleStartOver()">
                      <i class="fa-solid fa-rotate-left"></i> Start Over
                    </button>
                    <button type="submit" 
                            class="usa-button usa-button--small width-auto tablet:display-none margin-right-0"
                            (click)="handleStartOver()">
                      <i class="fa-solid fa-rotate-left"></i> Start Over
                    </button>
                  </div>
                </div>
              </div>
            </div>
            @if (!canShowMap && displayResults.length === 0) {
              <div class="grid-row">
                <div class="grid-col-12 margin-bottom-3">
                  There are no health centers available within {{ selectedRadius }} miles around the search location.
                </div>
              </div>
              @if (getRadiusIndex() < radiiForLocations.length - 1) {
                <div class="grid-row">
                  <div class="grid-col-12 margin-bottom-10">
                    Please try searching for a different location, or 
                    <a href="javascript:void(0)" (click)="increaseRadius()" class="usa-link">increase the search radius to {{ radiiForLocations[getRadiusIndex() + 1].value }} miles</a>.
                  </div>
                </div>
              }
            }
            @if (canShowMap) {
              <div class="grid-row hide-on-desktop padding-bottom-2">
                <div class="grid-col-12 tablet:grid-col-6 map-height">
                  @if (displayResults && displayResults.length > 0) {
                    <hdw-pdf-export [canShowPdfExport]="canShowPdfExport"></hdw-pdf-export>
                    <hdw-map-container
                      (selectedMarkerEmitter)="handleSelectedMarker($event)"
                      [locationData]="locationData"
                      [setFocus]="setFocus"
                    ></hdw-map-container>
                  }
                </div>
              </div>
              <div>
                <div
                  class="grid-row grid-gap padding-bottom-4"
                  [ngClass]="displayResults && displayResults.length ? '' : 'padding-top-4'"
                >
                  <div class="grid-col-12 tablet:grid-col-6">
                    <hdw-filter-by (filterByEmitter)="handleFilterBy($event)"></hdw-filter-by>
                    <div class="grid-row padding-x-2">
                      <div id="results" class="grid-col-12">
                        @if (displayResults && displayResults.length != 0) {
                          @for (result of displayResults; track result) {
                            <div
                              [ngClass]="selectedId === result.Id ? 'selected-result' : ''"
                              class="grid-row grid-gap border-top-1px border-base padding-top-2"
                            >
                              <div class="grid-col-auto padding-0" (click)="handleAddressFocus(result)">
                                <div class="circle-5 bg-base-dark text-white text-bold display-flex flex-align-center flex-justify-center font-ui-xs">
                                {{ result.index }}
                                </div>
                              </div>
                              <div class="grid-col-fill display-flex flex-wrap">
                                <div class="flex-fill line-height-sans-5 minw-card-lg margin-right-1 margin-bottom-105">
                                  <!--Distance-->
                                  <span class="font-ui-3xs display-block text-base-darker"
                                    >{{ result.Distance }} MILES</span
                                  >
                                  <!--Location Name-->
                                  <span class="font-ui-sm text-bold display-block">{{ result.CtrNm }}</span>
                                  <!--Operated By-->
                                  <span class="font-ui-sm display-block"
                                    >Operated by {{ result.ParentCtrNm }}</span
                                  >
                                  <!--Address Street-->
                                  <span class="font-ui-sm display-block text-base-darker">{{
                                    result.CtrAddress
                                  }}</span>
                                  <!--Address City-->
                                  <span class="font-ui-sm display-block text-base-darker"
                                    >{{ result.CtrCity }}, {{ result.CtrStateAbbr }} {{ result.CtrZipCd }}</span
                                  >
                                </div>
                                <div class="margin-bottom-2">
                                  <div class="display-flex flex-align-start flex-justify-start text-no-wrap">
                                    @if (result.UrlTxt) {
                                      <a href="javascript:void(0)" 
                                         (click)="openExternalLinkDisclaimer(result.UrlTxt)"
                                         class="usa-link usa-link--novisited text-no-underline display-flex flex-column flex-align-center">
                                        <div class="border-primary border-1px circle-5 bg-neutral-subtle display-flex flex-align-center flex-justify-center margin-bottom-05">
                                          <i class="fa-solid fa-earth-americas" aria-label="website"></i>
                                        </div>
                                        <span class="usa-link usa-link--external text-no-underline hover:text-underline">
                                          Website
                                        </span>
                                      </a>
                                    } @else {
                                      <div class="rich-tooltip rich-tooltip--inverse">
                                        <div class="rich-tooltip__trigger display-flex flex-column flex-align-center" tabindex="0">
                                          <div class="border-base border-1px circle-5 bg-neutral-subtle display-flex flex-align-center flex-justify-center margin-bottom-05">
                                            <i class="fa-solid fa-earth-americas text-base" aria-disabled="true" title="website"></i>
                                          </div>
                                          <span class="text-base">Website</span>
                                        </div>

                                        <div class="rich-tooltip__container width-auto bottom-full">
                                          <div class="rich-tooltip__body">
                                            No website provided.
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    @if (result.CtrPhoneNum) {
                                      <a [href]="'tel:' + result.CtrPhoneNum" target="_blank" class="usa-link usa-link--novisited text-no-underline display-flex flex-column flex-align-center margin-x-105">
                                        <div class="border-primary border-1px circle-5 bg-neutral-subtle display-flex flex-align-center flex-justify-center margin-bottom-05">
                                          <i class="fa-solid fa-phone" aria-label="phone"></i>
                                        </div>
                                        <span class="usa-link text-no-underline hover:text-underline">
                                          Call
                                        </span>
                                      </a>
                                    } @else {
                                      <div class="rich-tooltip rich-tooltip--inverse">
                                        <div class="rich-tooltip__trigger display-flex flex-column flex-align-center" tabindex="0">
                                          <div class="border-base border-1px circle-5 bg-neutral-subtle display-flex flex-align-center flex-justify-center margin-bottom-05">
                                            <i class="fa-solid fa-phone text-base" aria-disabled="true" title="phone"></i>
                                          </div>
                                          <span class="text-base">Call</span>
                                        </div>

                                        <div class="rich-tooltip__container width-auto bottom-full">
                                          <div class="rich-tooltip__body">
                                            No phone number provided.
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    <a [href]="result.directionsUrl" target="_blank" class="usa-link usa-link--novisited text-no-underline display-flex flex-column flex-align-center">
                                      <div class="border-primary border-1px circle-5 bg-neutral-subtle display-flex flex-align-center flex-justify-center margin-bottom-05">
                                        <i class="fa-solid fa-diamond-turn-right" aria-label="directions"></i>
                                      </div>
                                      <span class="usa-link text-no-underline hover:text-underline">
                                        Directions
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        }
                        @if (displayResults && displayResults.length === 0) {
                          <div class="line-height-body-3">
                            <div class="margin-bottom-2">
                              There are no health centers that match the selected filter.
                            </div>
                            @if (getRadiusIndex() < radiiForLocations.length - 1) {
                              <div class="margin-bottom-2">
                                Please try searching for a different location, or 
                                <a href="javascript:void(0)" (click)="increaseRadius()" class="usa-link">increase the search radius to {{ radiiForLocations[getRadiusIndex() + 1].value }} miles</a>.
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="border-top-1px border-base">
                      <div class="grid-row padding-top-4">
                        <div class="grid-col-12 tablet:grid-col-6">
                          @if (totalResults) {
                            <span class="font-ui-sm"
                              >Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ totalResults }} results</span
                            >
                          }
                        </div>
                        @if (totalResults && locationData?.locations?.length > rows) {
                          <div class="grid-col-12 tablet:grid-col-6">
                            <hdw-paginator
                              [maxNumberOfPages]="4"
                              [rows]="rows"
                              [totalRecords]="totalResults"
                              (selectedIndexEmitter)="handleSelectedIndex($event)"
                              [updateSelectedIndex]="updateSelectedIndex"
                            ></hdw-paginator>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="grid-col-12 tablet:grid-col-6 map-height hide-on-mobile">
                    @if (displayResults && displayResults.length > 0) {
                      <hdw-pdf-export [canShowPdfExport]="canShowPdfExport"></hdw-pdf-export>
                      <hdw-map-container
                        (selectedMarkerEmitter)="handleSelectedMarker($event)"
                        [locationData]="locationData"
                        [setFocus]="setFocus"
                      ></hdw-map-container>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </section>
      }
    </main>

    <div class="usa-modal tablet:maxw-tablet desktop:maxw-tablet-lg"
         id="share-modal"
         role="dialog"
         title="Share This Page"
         aria-labelledby="share-modal-head"
         aria-describedby="share-modal-desc">
      <div class="usa-modal__content">
        <div class="usa-modal__main">
          <h2 class="usa-modal__heading margin-bottom-0" id="share-modal-head">
            Share This Page
          </h2>
          <div class="usa-prose" id="share-modal-desc">
            <p class="margin-top-2 margin-bottom-1">
              Share this link via
            </p>
            <div class="display-flex flex-column tablet:flex-row flex-wrap flex-align-start gap-2 margin-top-0">
              <button type="button" class="usa-button usa-button--outline width-auto margin-bottom-1" (click)="shareMail()">
                <i class="fa-solid fa-at margin-right-1"></i>Email
              </button>
              <button type="button" class="usa-button usa-button--outline width-auto margin-bottom-1 tablet:display-none" (click)="shareSms()">
                <i class="fa-solid fa-comment margin-right-1"></i>SMS
              </button>
              <button type="button" class="usa-button usa-button--outline width-auto margin-bottom-1" (click)="shareLinkedIn()">
                <i class="fa-brands fa-linkedin margin-right-1"></i>LinkedIn
              </button>
              <button type="button" class="usa-button usa-button--outline width-auto margin-bottom-1" (click)="shareTwitter()">
                <i class="fa-brands fa-x-twitter margin-right-1"></i>X (Twitter)
              </button>
              <button type="button" class="usa-button usa-button--outline width-auto margin-bottom-1" (click)="shareFacebook()">
                <i class="fa-brands fa-facebook margin-right-1"></i>Facebook
              </button>
            </div>
            <p>
              Or copy link via
            </p>
            <div class="border-1px border-base-dark radius-md display-flex flex-row flex-align-stretch margin-top-05 overflow-hidden">
              <div class="display-flex flex-row flex-align-center flex-fill padding-y-1 padding-left-2 padding-right-1 overflow-hidden flex-min-width-0">
                <i class="fa-solid fa-link margin-right-1 flex-shrink-0"></i>
                <span class="text-base-darker whitespace-nowrap text-ellipsis-1">{{copyText}}</span>
              </div>
              <button type="button" class="usa-button radius-0 margin-right-0 width-auto btn-min-width flex-shrink-0" (click)="copyLink()">
                <span class="usa-sr-only">Copy</span>
                <i class="fa-solid fa-copy"></i>
              </button>
            </div>
          </div>
          <div class="usa-modal__footer">
          </div>
        </div>
        <button type="button" class="usa-button usa-modal__close height-4" aria-label="Close this window" data-close-modal>
          <i class="fa-regular fa-2xl fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</div>
